/**
 * @author Fernando Ruano
 * @file index.js
 * @description Patients Container
 */

// Dependencies
import React from 'react';
// import PropTypes from 'prop-types';

// Components
import AppRoutes from '@nephro/components/AppRoutes';
import AppCardLayout from '@nephro/components/AppCardLayout';

// Routes
import routes from './routes';

/**
 * Patients Container.
 * @return { Node } React Patients container.
 */
const PatientsContainer = () => {
  return (
    <AppCardLayout>
      <AppRoutes routes={routes} />
    </AppCardLayout>
  );
};

/**
 * @name Patients.propTypes
 * @type { Object }
 */
PatientsContainer.propTypes = {};

/**
 * Default props
 */
PatientsContainer.defaultProps = {};

export default PatientsContainer;
